document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.card-wrapper').forEach((card) => {
    const addBtn = card.querySelector('.add-to-cart-btn');
    const selects = card.querySelectorAll('.variant-selector select');
    const priceWrapper = card.querySelector('[data-price-wrapper]');
    const productId = addBtn?.dataset.productId;
    if (!productId) return;

    const product = window.__PRODUCTS__?.[productId];
    let selectedOptions = {};
    selects.forEach((sel) => (selectedOptions[sel.name] = sel.value));

    // --- Update price + variant id ---
    async function updateVariantAndPrice() {
      if (!product) return;

      const match = product.variants.find((v) =>
        v.options.every((opt, i) => opt === Object.values(selectedOptions)[i])
      );

      if (match) {
        addBtn.dataset.defaultVariant = match.id;

        // Fetch updated price snippet for this variant
        try {
          const url = `${window.Shopify.routes.root}products/${productId}?variant=${match.id}&section_id=price`;
          const res = await fetch(url);
          const html = await res.text();

          // Extract inner HTML of price section
          const newPriceHTML = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('.price')?.outerHTML;

          if (newPriceHTML && priceWrapper) {
            priceWrapper.innerHTML = newPriceHTML;
          }
        } catch (err) {
          console.warn('Price update failed', err);
        }
      }
    }

    selects.forEach((sel) => {
      sel.addEventListener('change', (e) => {
        selectedOptions[e.target.name] = e.target.value;
        updateVariantAndPrice();
      });
    });

    // --- Add to cart + open drawer ---
    addBtn.addEventListener('click', async () => {
      let variantId = addBtn.dataset.defaultVariant;
      if (!variantId && product?.variants?.length === 1) {
        variantId = product.variants[0].id;
      }
      if (!variantId) return;

      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';

      try {
        // Add to cart
        const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });

        if (!res.ok) throw new Error('Add failed');

        // Fetch updated sections (drawer + icon)
        const sectionRes = await fetch(
          `${window.Shopify.routes.root}?sections=cart-drawer`
        );
        const sectionHTML = await sectionRes.json();

        const cartDrawer = document.querySelector('cart-drawer');
        const drawerSelector = '#CartDrawer';
        const parsed = new DOMParser().parseFromString(sectionHTML['cart-drawer'], 'text/html');
        const newDrawerInner = parsed.querySelector(drawerSelector);

        if (cartDrawer && newDrawerInner) {
          if (!cartDrawer.querySelector(drawerSelector) || !cartDrawer.innerHTML.trim()) {
            cartDrawer.innerHTML = newDrawerInner.outerHTML;
          } else {
            const drawerEl = cartDrawer.querySelector(drawerSelector);
            drawerEl.innerHTML = newDrawerInner.innerHTML;
          }
          cartDrawer.classList.add('animate', 'active');
          document.body.classList.add('overflow-hidden');
          cartDrawer.classList.remove('is-empty');
        }

        // Update header cart bubble
       // --- Update header cart bubble (icon + count) ---
const cartIcon = document.querySelector('#cart-icon-bubble');

if (cartIcon && sectionHTML['cart-icon-bubble']) {
  const newHTML = getSectionInnerHTML(sectionHTML['cart-icon-bubble'], '#cart-icon-bubble');
  cartIcon.innerHTML = newHTML;
} else {
  // Fallback: fetch cart to rebuild count manually
  try {
    const cartData = await fetch(`${window.Shopify.routes.root}cart.js`).then(r => r.json());
    const count = cartData.item_count;

    let bubble = cartIcon?.querySelector('.cart-count-bubble');
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      cartIcon?.appendChild(bubble);
    }

    bubble.innerHTML = `
      <span aria-hidden="true">${count}</span>
      <span class="visually-hidden">${count} items</span>
    `;
  } catch (err) {
    console.warn('Cart count update failed', err);
  }
}


        addBtn.textContent = 'Added!';
        setTimeout(() => (addBtn.textContent = 'Add to cart'), 1500);
      } catch (err) {
        console.error('Cart error:', err);
        addBtn.textContent = 'Error';
      } finally {
        addBtn.disabled = false;
      }
    });
  });

  // Helper
  function getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector(selector);
    return el ? el.innerHTML : '';
  }
});




